import BaseClass from './BaseClass';

export default class BaseService extends BaseClass {
  constructor(config) {
    super({ name: config.name, type: 'Service' });
  }

  async sendClientRequest(client, settings, errorMsg) {
    return new Promise(async (resolve, reject) => {
      const response = await client.sendRequest(settings)
        .catch((err) => {
          this.logError(`${errorMsg}: ${err}`);
          reject(err);
        });
      resolve(response);
    });
  }
}
